export const GET_UNIT_PENDING = "GET_UNIT_PENDING";
export const GET_MORE_UNIT_PENDING = "GET_MORE_UNIT_PENDING";
export const GET_UNIT_SUCCESS = "GET_UNIT_SUCCESS";
export const GET_MORE_UNIT_SUCCESS = "GET_MORE_UNIT_SUCCESS";
export const RESET_UNIT = "RESET_UNIT";
